import { render, staticRenderFns } from "./DocumentDepartmentGroupDialogSelector.vue?vue&type=template&id=d9d0ce5c&scoped=true&"
import script from "./DocumentDepartmentGroupDialogSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentDepartmentGroupDialogSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentDepartmentGroupDialogSelector.vue?vue&type=style&index=0&id=d9d0ce5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d0ce5c",
  null
  
)

export default component.exports